export const SearchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20">
    <path
      fill="var(--gold-2)"
      d="M2.5 8.75A6.189 6.189 0 018.75 2.5 6.189 6.189 0 0115 8.75 6.189 6.189 0 018.75 15 6.189 6.189 0 012.5 8.75zm15.375 10.875a1.237 1.237 0 001.75-1.75L15.75 14a8.558 8.558 0 001.75-5.25A8.7 8.7 0 008.75 0 8.7 8.7 0 000 8.75a8.7 8.7 0 008.75 8.75A8.558 8.558 0 0014 15.75l3.875 3.875z"
    />
  </svg>
);

export const MailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="29.032" height="18">
    <path
      fill="var(--gold-2)"
      d="M27.082 2.924v13.125H1.951V3l12.736 9.316zM3.827 1.952h21.308L14.667 9.88zM0 18h29.032V0H0z"
    />
  </svg>
);
